"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5053],{

/***/ 96679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: ",
        ";\n    height: ",
        ";\n    background-color: rgba(0, 0, 0, 0.11);\n    border-radius: 4px;\n    animation: pulse 1.5s ease-in-out 0.5s infinite;\n\n    @keyframes pulse {\n      0% {\n        opacity: 1;\n      }\n      50% {\n        opacity: 0.4;\n      }\n      100% {\n        opacity: 1;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Skeleton = function(param) {
    var _width = param.width, width = _width === void 0 ? "auto" : _width, _height = param.height, height = _height === void 0 ? 16 : _height, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        width: width,
        height: height,
        className: className
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Skeleton);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Skeleton__StyledWrapper",
    componentId: "sc-62e13890-0"
})(_templateObject1(), function(param) {
    var width = param.width, height = param.height;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), typeof width === "number" ? "".concat(width, "px") : width, typeof height === "number" ? "".concat(height, "px") : height);
});


/***/ }),

/***/ 83821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #01a0ff;\n  text-decoration: underline;\n  margin-right: 10px;\n\n  &:hover {\n    color: #01a0ff;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var SnackbarLink = function(param) {
    var href = param.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
            target: "_blank",
            rel: "noreferrer",
            children: "보러가기"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SnackbarLink);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    displayName: "SnackbarLink__StyledWrapper",
    componentId: "sc-264aa138-0"
})(_templateObject());


/***/ }),

/***/ 35949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 32px;\n    box-sizing: border-box;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2px 0;\n    border: 1px solid ",
        ";\n    border-radius: 3px;\n    margin-right: 5px;\n    color: ",
        ";\n    font-size: 11px;\n    font-weight: bold;\n    vertical-align: top;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var RecommendedTag = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        children: "추천"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RecommendedTag);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    displayName: "RecommendedTag__StyledWrapper",
    componentId: "sc-296d5942-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), theme.color.secondary_1, theme.color.secondary_1);
});


/***/ }),

/***/ 12163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ab": function() { return /* binding */ LIST_OFFSET_DEFAULT; },
/* harmony export */   "Qm": function() { return /* binding */ TEAM_RECRUIT_POST_BUTTON_VISIBLE_ACTIVITY_TYPE; },
/* harmony export */   "ep": function() { return /* binding */ TEAM_RECRUIT_VISIBLE_ACTIVITY_TYPE; },
/* harmony export */   "gH": function() { return /* binding */ CHAT_ROOM_JOINABLE_ACTIVITY_TYPE; },
/* harmony export */   "sC": function() { return /* binding */ LIST_LIMIT_DEFAULT; },
/* harmony export */   "z3": function() { return /* binding */ ACTIVITY_PAGE_TYPE; }
/* harmony export */ });
/* harmony import */ var constants_enums__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35460);

var LIST_OFFSET_DEFAULT = 0;
var LIST_LIMIT_DEFAULT = 10;
var ACTIVITY_PAGE_TYPE = constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .PageType.ACTIVITY */ .GV.ACTIVITY;
var CHAT_ROOM_JOINABLE_ACTIVITY_TYPE = [
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.CONTEST */ .kF.CONTEST,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION, 
];
var TEAM_RECRUIT_VISIBLE_ACTIVITY_TYPE = [
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, 
];
var TEAM_RECRUIT_POST_BUTTON_VISIBLE_ACTIVITY_TYPE = [
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY,
    constants_enums__WEBPACK_IMPORTED_MODULE_0__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, 
];


/***/ }),

/***/ 50516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var app_styled_media__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68250);
/* harmony import */ var _useMediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27963);


var useIsMobile = function() {
    var matches = (0,_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("(max-width: ".concat(app_styled_media__WEBPACK_IMPORTED_MODULE_0__/* .mobileBreakPointSize */ .Zq, "px)"));
    return matches;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);


/***/ }),

/***/ 27963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * React hook to evaluate a CSS media query and return whether it matches.
 *
 * Usage example:
 *   const isDesktop = useMediaQuery('(min-width: 960px)')
 *
 * @param query - A valid CSS media query string
 *   e.g. '(min-width: 960px)', '(max-width: 600px)'
 *
 * @param defaultMatches - Initial match value used during SSR (server-side rendering).
 *   - SSR에서는 `window.matchMedia`를 사용할 수 없으므로 기본값을 사용합니다.
 *   - 기본값은 false이며, 필요하다면 UA 기반으로 true/false를 전달할 수 있습니다.
 *   - 예: `useMediaQuery('(min-width: 960px)', { defaultMatches: isDesktopUA })`
 *
 * ⚠️ 주의
 * - query에는 반드시 완전한 미디어 문자열(@media 없이)만 넣어야 합니다.
 *   예: "tabletBreakPoint" 같은 상수가 있다면, 실제 문자열 "(min-width: 960px)" 형태로 전달해야 합니다.
 * - defaultMatches는 선택값이며, SSR 환경에서 깜빡임(mismatch)을 줄이려면
 *   UA(user agent) 기반 값을 넘겨주는 것이 좋습니다.
 */ var useMediaQuery = function(query) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _defaultMatches = ref.defaultMatches, defaultMatches = _defaultMatches === void 0 ? false : _defaultMatches;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultMatches), matches = ref1[0], setMatches = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var mql = window.matchMedia(query);
        var onChange = function() {
            setMatches(mql.matches);
        };
        onChange();
        if (mql.addEventListener) {
            mql.addEventListener("change", onChange);
        } else {
            // Safari < 14 fallback
            mql.addListener(onChange);
        }
        return function() {
            if (mql.removeEventListener) {
                mql.removeEventListener("change", onChange);
            } else {
                mql.removeListener(onChange);
            }
        };
    }, [
        query
    ]);
    return matches;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMediaQuery);


/***/ }),

/***/ 70525:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ActivityListCardItem_ActivityListCardItem; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__(78718);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.components/Skeleton.tsx
var Skeleton = __webpack_require__(96679);
// EXTERNAL MODULE: ./src/app.feature/activityDetail/constant/activity.constant.ts
var activity_constant = __webpack_require__(12163);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(50516);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/app.components/tag/RecommendedTag.tsx
var RecommendedTag = __webpack_require__(35949);
// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
// EXTERNAL MODULE: ./src/components/ActivityListCardItem/module/getLimitNumText.ts
var getLimitNumText = __webpack_require__(36957);
;// CONCATENATED MODULE: ./src/components/ActivityListCardItem/components/ManagerReplyBadge.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 24px;\n    display: flex;\n    border-radius: 3px;\n    padding: 5px;\n    background-color: rgba(0, 0, 0, 0.9);\n    font-size: 10px;\n    color: ",
        ";\n    font-weight: bold;\n\n    .reply-count {\n      color: #ffd800;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var ManagerReplyBadge = function(param) {
    var managerRepliesCount = param.managerRepliesCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: managerRepliesCount ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "담당자 답변 "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "reply-count",
                    children: (0,getLimitNumText/* getLimitNumText */.i)({
                        number: managerRepliesCount,
                        limit: 99
                    })
                })
            ]
        }) : "담당자 답변받기"
    });
};
/* harmony default export */ var components_ManagerReplyBadge = (ManagerReplyBadge);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ManagerReplyBadge__StyledWrapper",
    componentId: "sc-e4455f3a-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.background.bg_8);
});

// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/constants/enums.ts
var enums = __webpack_require__(35460);
// EXTERNAL MODULE: ./src/utils/optimizeImageUrl.ts
var optimizeImageUrl = __webpack_require__(65342);
// EXTERNAL MODULE: ./src/components/ActivityListCardItem/ScrapBoxButton.tsx
var ScrapBoxButton = __webpack_require__(83052);
// EXTERNAL MODULE: ./src/components/ActivityListCardItem/SecondInfoText.tsx
var SecondInfoText = __webpack_require__(11551);
;// CONCATENATED MODULE: ./src/components/ActivityListCardItem/components/TeamRecruitBadge.tsx

function TeamRecruitBadge_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 24px;\n    display: flex;\n    border-radius: 3px;\n    padding: 5px;\n    background-color: #0132ff;\n    opacity: 0.9;\n    color: ",
        ";\n    font-weight: bold;\n    font-size: 10px;\n\n    .recruit-post-count {\n      margin-left: 1px;\n      color: #ffd800;\n    }\n  "
    ]);
    TeamRecruitBadge_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TeamRecruitBadge_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    TeamRecruitBadge_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var TeamRecruitBadge = function(param) {
    var teamRecruitPostCount = param.teamRecruitPostCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TeamRecruitBadge_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "팀원 모집"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "recruit-post-count",
                children: (0,getLimitNumText/* getLimitNumText */.i)({
                    number: teamRecruitPostCount,
                    limit: 99
                })
            })
        ]
    });
};
/* harmony default export */ var components_TeamRecruitBadge = (TeamRecruitBadge);
var TeamRecruitBadge_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "TeamRecruitBadge__StyledWrapper",
    componentId: "sc-d187607c-0"
})(TeamRecruitBadge_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(TeamRecruitBadge_templateObject(), theme.background.bg_8);
});

;// CONCATENATED MODULE: ./src/components/ActivityListCardItem/ActivityListCardItem.tsx



function ActivityListCardItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ActivityListCardItem_currentUser on User {\n    ...ActivityScrap_currentUser\n  }\n  fragment ActivityListCardItem_activity on Activity {\n    id\n    title\n    type\n    thumbnailImage {\n      id\n      url\n    }\n    logoImage {\n      id\n      url\n    }\n    manager {\n      id\n      isStaff\n      channel {\n        id\n        url\n      }\n    }\n    chatRoom {\n      id\n    }\n    managerReplies {\n      id\n    }\n    organizationName\n    scrapCount\n    isScrapped\n    teamRecruitPostCount\n    ...ActivityListCardItem_SecondInfoText_activity\n    ...ActivityScrap_activity\n  }\n"
    ]);
    ActivityListCardItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ActivityListCardItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    .image-wrapper {\n      position: relative;\n      height: 0;\n      overflow: hidden;\n      padding-top: 100%;\n      border: 1px solid #e8e8e8;\n      border-radius: 5px;\n\n      .skeleton-rect {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        border-radius: 5px;\n      }\n      .image-link {\n        position: absolute;\n        top: 0;\n        left: 0;\n        display: grid;\n        width: 100%;\n        height: 100%;\n\n        overflow: hidden;\n\n        .activity-image {\n          width: 100% !important;\n          height: auto !important;\n          min-height: auto !important;\n        }\n      }\n\n      .badge-wrapper {\n        display: flex;\n        gap: 4px;\n        position: absolute;\n        left: ",
        ";\n        bottom: ",
        ";\n      }\n    }\n    .card-content {\n      display: grid;\n      gap: 5px;\n      padding: 10px 0 0 0;\n\n      .title-skeleton {\n        margin: 10px 0px;\n      }\n      .skeleton-wrapper {\n        display: flex;\n        gap: 10px;\n      }\n      .activity-title {\n        display: -webkit-box;\n        height: 45px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        word-break: break-all;\n        font-size: 16px;\n        font-weight: bold;\n        margin-bottom: 5px;\n        ",
        " {\n          height: 41px;\n          font-size: 14px;\n        }\n      }\n      .organization-name {\n        font-size: 12px;\n        font-weight: 500;\n        margin-bottom: 5px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 1;\n      }\n    }\n  "
    ]);
    ActivityListCardItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





















src_default()(ActivityListCardItem_templateObject());
var ActivityListCardItem = function(param) {
    var activity = param.activity, currentUser = param.currentUser, isLoading = param.isLoading, className = param.className, cardImageProps = param.cardImageProps, linkProps = param.linkProps, _managerBadgeOn = param.managerBadgeOn, managerBadgeOn = _managerBadgeOn === void 0 ? true : _managerBadgeOn, _teamRecruitBadgeOn = param.teamRecruitBadgeOn, teamRecruitBadgeOn = _teamRecruitBadgeOn === void 0 ? false : _teamRecruitBadgeOn, secondinfoTextProps = param.secondinfoTextProps, cardTitle = param.cardTitle, isRecommend = param.isRecommend, onClick = param.onClick;
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,next_router.useRouter)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var isRecruit = (activity === null || activity === void 0 ? void 0 : activity.type) === enums/* ActivityTypeID.RECRUIT */.kF.RECRUIT;
    var isTeamRecruitAvailable = (activity === null || activity === void 0 ? void 0 : activity.type) && activity_constant/* TEAM_RECRUIT_VISIBLE_ACTIVITY_TYPE.includes */.ep.includes(activity.type) && (activity === null || activity === void 0 ? void 0 : activity.teamRecruitPostCount) > 0;
    var ActivityItemLinkProps = {
        href: "/activity/[id]",
        as: "/activity/".concat(activity === null || activity === void 0 ? void 0 : activity.id),
        naked: true,
        onClick: function() {
            return onClick && onClick();
        }
    };
    var secondInfos = pick_default()(activity, [
        "recruitCloseAt",
        "recruitType",
        "replyCount",
        "viewCount", 
    ]);
    var imageUrl = (cardImageProps === null || cardImageProps === void 0 ? void 0 : cardImageProps.src) || (isRecruit ? activity === null || activity === void 0 ? void 0 : (ref = activity.logoImage) === null || ref === void 0 ? void 0 : ref.url : activity === null || activity === void 0 ? void 0 : (ref1 = activity.thumbnailImage) === null || ref1 === void 0 ? void 0 : ref1.url) || "";
    var imageWidth = (0,react.useMemo)(function() {
        if (cardImageProps === null || cardImageProps === void 0 ? void 0 : cardImageProps.width) {
            return cardImageProps === null || cardImageProps === void 0 ? void 0 : cardImageProps.width;
        } else {
            return isMobile ? 300 : 250;
        }
    }, [
        cardImageProps === null || cardImageProps === void 0 ? void 0 : cardImageProps.width,
        isMobile
    ]);
    var handleClickOrganization = function() {
        var ref;
        if (activity === null || activity === void 0 ? void 0 : (ref = activity.manager) === null || ref === void 0 ? void 0 : ref.channel) {
            router.push((0,util/* getWebviewHref */.ys)("/channel/".concat(activity.manager.channel.url), isWebview));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActivityListCardItem_StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "image-wrapper",
                children: [
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        className: "skeleton-rect"
                    }),
                    !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                className: "image-link"
                            }, ActivityItemLinkProps, linkProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    loader: optimizeImageUrl/* imageLoader */.X,
                                    alt: (cardImageProps === null || cardImageProps === void 0 ? void 0 : cardImageProps.alt) || (activity === null || activity === void 0 ? void 0 : activity.title) || "",
                                    className: "activity-image",
                                    width: imageWidth,
                                    height: imageWidth,
                                    src: (0,optimizeImageUrl/* optimizeImageUrl */.m)({
                                        url: imageUrl,
                                        width: imageWidth,
                                        height: "auto"
                                    }),
                                    objectFit: "cover"
                                }, "activity-image-".concat(activity === null || activity === void 0 ? void 0 : activity.id))
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrapBoxButton/* default */.Z, {
                                activity: activity,
                                currentUser: currentUser
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "badge-wrapper",
                                children: [
                                    managerBadgeOn && !(activity === null || activity === void 0 ? void 0 : (ref2 = activity.manager) === null || ref2 === void 0 ? void 0 : ref2.isStaff) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ManagerReplyBadge, {
                                        managerRepliesCount: (activity === null || activity === void 0 ? void 0 : (ref3 = activity.managerReplies) === null || ref3 === void 0 ? void 0 : ref3.length) || 0
                                    }),
                                    teamRecruitBadgeOn && isTeamRecruitAvailable && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TeamRecruitBadge, {
                                        teamRecruitPostCount: activity.teamRecruitPostCount
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card-content",
                children: [
                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                height: 36,
                                width: "100%",
                                className: "title-skeleton"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                height: 12,
                                width: "100%"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "skeleton-wrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 12,
                                        width: "30%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 12,
                                        width: "30%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        height: 12,
                                        width: "30%"
                                    })
                                ]
                            })
                        ]
                    }),
                    !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ActivityItemLinkProps), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                    className: "activity-title",
                                    children: [
                                        isRecommend && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedTag/* default */.Z, {}),
                                        cardTitle || (activity === null || activity === void 0 ? void 0 : activity.title) || "-"
                                    ]
                                })
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "organization-name",
                                        style: {
                                            cursor: (activity === null || activity === void 0 ? void 0 : (ref4 = activity.manager) === null || ref4 === void 0 ? void 0 : ref4.channel) ? "pointer" : "default"
                                        },
                                        onClick: handleClickOrganization,
                                        children: (activity === null || activity === void 0 ? void 0 : activity.organizationName) || "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondInfoText/* default */.Z, (0,_object_spread/* default */.Z)({
                                        activityInfos: secondInfos
                                    }, secondinfoTextProps))
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ActivityListCardItem_ActivityListCardItem = (ActivityListCardItem);
var ActivityListCardItem_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ActivityListCardItem__StyledWrapper",
    componentId: "sc-eb439f06-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(ActivityListCardItem_templateObject1(), theme.isMobile ? "5px" : "8px", theme.isMobile ? "5px" : "8px", media/* mobileBreakPoint */.vm);
});


/***/ }),

/***/ 83052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30132);
/* harmony import */ var components_ActivityScrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91202);
/* harmony import */ var svgIcons_BookMark__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49123);
/* harmony import */ var _module_getLimitNumText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36957);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 3px 8px;\n  gap: 6px;\n  border-radius: 3px;\n  color: #fff;\n  background-color: rgba(0, 0, 0, 0.7);\n  cursor: pointer;\n\n  &[data-is-scrap='true'] {\n    background-color: #01a0ff;\n  }\n\n  .scrap-icon {\n    width: 7.5px;\n    height: 10px;\n  }\n  .scrap-count {\n    font-size: 12px;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ScrapBoxButton = function(param) {
    var activity = param.activity, className = param.className;
    var handleClickScrapStopPropagation = function(scrapActivity) {
        return function(e) {
            e.stopPropagation();
            scrapActivity();
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_ActivityScrap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        activity: activity,
        children: function(param) {
            var scrapActivity = param.scrapActivity, scrapCount = param.scrapCount;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
                className: className,
                onClick: handleClickScrapStopPropagation(scrapActivity),
                "data-is-scrap": activity === null || activity === void 0 ? void 0 : activity.isScrapped,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_BookMark__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        className: "scrap-icon",
                        isOn: activity === null || activity === void 0 ? void 0 : activity.isScrapped
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "scrap-count",
                        children: (0,_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_4__/* .getLimitNumText */ .i)({
                            number: scrapCount !== null && scrapCount !== void 0 ? scrapCount : 0,
                            limit: 999
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScrapBoxButton);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ScrapBoxButton__StyledWrapper",
    componentId: "sc-88d97c8c-0"
})(_templateObject());


/***/ }),

/***/ 11551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var date_fns_differenceInCalendarDays__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92300);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14293);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30132);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93293);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47079);
/* harmony import */ var _app_modules_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50516);
/* harmony import */ var _module_getLimitNumText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36957);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ActivityListCardItem_SecondInfoText_activity on Activity {\n    recruitType\n    recruitCloseAt\n    viewCount\n    replyCount\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 10px;\n  font-size: 12px;\n  color: ",
        ";\n\n  .close-date-highlight {\n    font-weight: bold;\n    color: #ef2929;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










graphql_tag__WEBPACK_IMPORTED_MODULE_2___default()(_templateObject());
var getDDay = function(closeDate) {
    if (!closeDate) return null;
    var nowDate = new Date();
    return (0,date_fns_differenceInCalendarDays__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(closeDate, nowDate.getTime());
};
var getDDayText = function(dDay, recruitType) {
    if (!lodash_isNil__WEBPACK_IMPORTED_MODULE_3___default()(dDay)) {
        if (dDay < 0) return "마감";
        if (dDay === 0) {
            return "오늘마감";
        }
        return "D-".concat(dDay > 999 ? 999 : dDay);
    }
    switch(recruitType){
        case generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .ActivityRecruitType.ALWAYS */ .iS2.ALWAYS:
            return "상시";
        case generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .ActivityRecruitType.ASAP */ .iS2.ASAP:
            return "선착순";
        case generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .ActivityRecruitType.SCHEDULED */ .iS2.SCHEDULED:
            return "모집예정";
        default:
            return "모집정보 없음";
    }
};
var SecondInfoText = function(param) {
    var activityInfos = param.activityInfos, closeDateHighLightClassName = param.closeDateHighLightClassName;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().pathname;
    var isMobile = (0,_app_modules_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var ref;
    var dDayByCloseAt = getDDay((ref = activityInfos === null || activityInfos === void 0 ? void 0 : activityInfos.recruitCloseAt) !== null && ref !== void 0 ? ref : undefined);
    var isAlmostClosed = !lodash_isNil__WEBPACK_IMPORTED_MODULE_3___default()(dDayByCloseAt) && dDayByCloseAt <= 5;
    var isInActivityList = pathname.includes("/list");
    var ref1, ref2;
    var replyCount = isMobile ? (0,_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_8__/* .getLimitNumText */ .i)({
        number: (ref1 = activityInfos === null || activityInfos === void 0 ? void 0 : activityInfos.replyCount) !== null && ref1 !== void 0 ? ref1 : 0,
        limit: 99
    }) : (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .numberWithCommas */ .x6)((ref2 = activityInfos === null || activityInfos === void 0 ? void 0 : activityInfos.replyCount) !== null && ref2 !== void 0 ? ref2 : 0);
    var ref3;
    var viewCount = isMobile ? (0,_module_getLimitNumText__WEBPACK_IMPORTED_MODULE_8__/* .getLimitNumText */ .i)({
        number: activityInfos === null || activityInfos === void 0 ? void 0 : activityInfos.viewCount,
        limit: 99999
    }) : (0,utils__WEBPACK_IMPORTED_MODULE_5__/* .numberWithCommas */ .x6)((ref3 = activityInfos === null || activityInfos === void 0 ? void 0 : activityInfos.viewCount) !== null && ref3 !== void 0 ? ref3 : 0);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        isInActivityList: isInActivityList,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: isAlmostClosed ? "".concat(closeDateHighLightClassName, " close-date-highlight") : "",
                children: getDDayText(dDayByCloseAt !== null && dDayByCloseAt !== void 0 ? dDayByCloseAt : undefined, activityInfos === null || activityInfos === void 0 ? void 0 : activityInfos.recruitType)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                children: [
                    "조회 ",
                    viewCount
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                children: [
                    "댓글 ",
                    replyCount
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SecondInfoText);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SecondInfoText__StyledWrapper",
    componentId: "sc-dd9b84a2-0"
})(_templateObject1(), function(param) {
    var isInActivityList = param.isInActivityList;
    return isInActivityList ? "#666666" : "#999999";
});


/***/ }),

/***/ 91202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29496);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47079);
/* harmony import */ var _app_components_SnackbarLink_SnackbarLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83821);
/* harmony import */ var _app_feature_activityDetail_constant_activity_constant__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12163);
/* harmony import */ var _app_feature_chatting_chattingContext_module_ChattingContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18944);
/* harmony import */ var _app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67235);
/* harmony import */ var components_LoginAlert__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39749);
/* harmony import */ var hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38405);
/* harmony import */ var hooks_useErrorSnackbar__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96597);
/* harmony import */ var hooks_useFlutterInappwebview__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2165);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  fragment ActivityScrap_currentUser on User {\n    id\n    scrapCount\n  }\n\n  fragment ActivityScrap_activity on Activity {\n    id\n    isScrapped\n    scrapCount\n    activityTypeID\n    manager {\n      id\n      channel {\n        id\n        url\n        viewerHasFollowed\n      }\n    }\n    chatRoom {\n      id\n      viewerIsMember\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var ActivityScrap = function(props) {
    var activity = props.activity, children = props.children, refetchQueries = props.refetchQueries, update = props.update;
    var isWebview = (0,_app_modules_hooks_useIsWebview__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_4__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    var enqueueApolloError = (0,hooks_useErrorSnackbar__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)().enqueueApolloError;
    var joinChatRoom = (0,_app_feature_chatting_chattingContext_module_ChattingContext__WEBPACK_IMPORTED_MODULE_8__/* .useChattingContext */ .Y)().joinChatRoom;
    var fluterInappwebview = (0,hooks_useFlutterInappwebview__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)().fluterInappwebview;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showLoginAlert = ref[0], setShowLoginAlert = ref[1];
    var user = (0,hooks_useCurrentUser__WEBPACK_IMPORTED_MODULE_11__/* .useCurrentUserContext */ .O)().user;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,generated_graphql__WEBPACK_IMPORTED_MODULE_5__/* .useActivityScrapUpdateMutation */ .ha6)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
        onError: enqueueApolloError
    }, refetchQueries && {
        refetchQueries: refetchQueries,
        awaitRefetchQueries: true
    }), {
        update: update
    })), 2), activityScrapUpdate = ref1[0], loading = ref1[1].loading;
    var scrapCount = (activity === null || activity === void 0 ? void 0 : activity.scrapCount) || 0;
    var closeLoginAlert = function() {
        setShowLoginAlert(false);
    };
    var scrapActivity = function() {
        var ref, ref1, ref2;
        if (!(activity === null || activity === void 0 ? void 0 : activity.id)) {
            return;
        }
        if (!user) {
            setShowLoginAlert(true);
            return;
        }
        activityScrapUpdate({
            optimisticResponse: {
                __typename: "Mutation",
                activityScrapUpdate: {
                    __typename: "ActivityScrapUpdatePayload",
                    userScrap: {
                        id: "optimisticResponse_ID",
                        __typename: "UserScrap",
                        user: {
                            __typename: "User",
                            id: user.id,
                            scrapCount: ((user === null || user === void 0 ? void 0 : user.scrapCount) || 0) + ((activity === null || activity === void 0 ? void 0 : activity.isScrapped) ? -1 : 1),
                            scraps: []
                        }
                    },
                    activity: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, activity), {
                        id: activity.id,
                        isScrapped: !(activity === null || activity === void 0 ? void 0 : activity.isScrapped),
                        scrapCount: (activity.scrapCount || 0) + ((activity === null || activity === void 0 ? void 0 : activity.isScrapped) ? -1 : 1),
                        __typename: "Activity"
                    }),
                    scrapped: !(activity === null || activity === void 0 ? void 0 : activity.isScrapped)
                }
            },
            variables: {
                activityScrapUpdateInput: {
                    activityID: activity === null || activity === void 0 ? void 0 : activity.id,
                    referer: "/activity/".concat(activity === null || activity === void 0 ? void 0 : activity.id)
                },
                includeScrapUsers: false
            }
        });
        if (!activity.isScrapped && ((ref = activity.chatRoom) === null || ref === void 0 ? void 0 : ref.id) && _app_feature_activityDetail_constant_activity_constant__WEBPACK_IMPORTED_MODULE_7__/* .CHAT_ROOM_JOINABLE_ACTIVITY_TYPE.includes */ .gH.includes((activity === null || activity === void 0 ? void 0 : activity.activityTypeID) || -1)) {
            joinChatRoom(activity.chatRoom.id, activity.chatRoom.viewerIsMember);
        }
        if (!activity.isScrapped && ((ref1 = activity.manager) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.channel) === null || ref2 === void 0 ? void 0 : ref2.viewerHasFollowed) === false) {
            enqueueSnackbar("이 게시글을 등록한 기업을 팔로우했습니다.", {
                action: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_components_SnackbarLink_SnackbarLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    href: "/channel/".concat(activity.manager.channel.url)
                })
            });
        }
        // 스크랩을 모두 하나의 api에서 처리하기 때문에 스크랩 페이지에서 단건 삭제시에만 호출하도록 합니다
        if (isWebview) {
            activity.isScrapped ? fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportRemoveScrap") : fluterInappwebview === null || fluterInappwebview === void 0 ? void 0 : fluterInappwebview.callHandler("reportAddScrap");
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            children({
                loading: loading,
                scrapActivity: scrapActivity,
                scrapCount: scrapCount
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_LoginAlert__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                DialogProps: {
                    open: showLoginAlert
                },
                onRequestClose: closeLoginAlert
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ActivityScrap);
graphql_tag__WEBPACK_IMPORTED_MODULE_3___default()(_templateObject());


/***/ }),

/***/ 39749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17563);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_chatting_chattingContext_type_chattingQueryParams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75551);
/* harmony import */ var components_AlertDialog__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13133);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  & > b,\n  strong {\n    font-size: 18px;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var LoginAlert = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var goLogin = function() {
        var next = props.chatRoomId ? "".concat(window.location.href, "?").concat(_app_feature_chatting_chattingContext_type_chattingQueryParams__WEBPACK_IMPORTED_MODULE_4__/* .CHAT_OPEN_TYPE_QUERY_KEY */ .v, "=").concat(_app_feature_chatting_chattingContext_type_chattingQueryParams__WEBPACK_IMPORTED_MODULE_4__/* .CHAT_OPEN_TYPE.DEFAULT */ .X.DEFAULT, "&chatRoomId=").concat(props.chatRoomId) : window.location.href;
        router.push("/login?".concat(query_string__WEBPACK_IMPORTED_MODULE_3__.stringify({
            next: next
        })));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_AlertDialog__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                    children: "로그인 후 이용가능한 서비스입니다."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("b", {
                    children: "로그인 하시겠습니까?"
                })
            ]
        }),
        onConfirm: goLogin,
        confirmLabel: "확인"
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginAlert);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    displayName: "LoginAlert__StyledWrapper",
    componentId: "sc-de340b2b-0"
})(_templateObject());


/***/ }),

/***/ 65155:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({
    INVALID_REQUEST: "올바르지 않은 요청 입니다.",
    NO_RESPONSE_ERROR: "현재 서버에 응답이 없습니다. 잠시후 다시 시도해주세요",
    UNKNOWN_ERROR: "알 수 없는 오류가 발생했습니다.",
    FORBIDDEN: "요청할 수 있는 권한이 없습니다.",
    UNAUTHENTICATED: "계정이 인증되지 않았습니다. 로그인 확인 후 다시 시도해 보세요.",
    REQUIRED_LOGGED_IN: "로그인 후 사용할 수 있습니다.",
    NOT_FOUND_ERROR: "알 수 없는 오류가 발생했습니다.",
    ALREADY_EXISTING_EMAIL: "이미 가입된 이메일 입니다. 다른 이메일을 사용해주세요",
    ALREADY_EXISTING_NICKNAME: "이미 가입된 닉네임 입니다. 다른 닉네임을 사용해주세요",
    ALREADY_EXISTING_PHONE_NUMBER: "입력하신 휴대폰 번호는 이미 가입된 회원입니다.",
    INVALID_PHONE_NUMBER_FORMAT: "번호를 올바르게 입력해주세요",
    INVALID_AUTH_CODE: "인증번호가 일치하지 않습니다. 다시 확인해주세요.",
    ALREADY_JOINED_CHAT_ROOM: "이미 참여한 채팅방입니다.",
    TIMESPREAD_STATUS_REQUIRE_PARAMETER: "필요 파리미터 누락",
    TIMESPREAD_STATUS_OBJECT_NOT_EXIST: "일치하는 대상 없음",
    TIMESPREAD_STATUS_PHONE_ALREADY_AUTHORIZE: "이미 인증된 핸드폰 번호입니다.",
    TIMESPREAD_STATUS_PHONE_CODE_REQUEST_EXCEED: "휴대폰 인증 코드 요청 횟수가 초과 하였습니다.",
    TIMESPREAD_STATUS_PHONE_CODE_DATA_NOT_FOUND: "휴대폰 인증 코드 데이터 없음",
    TIMESPREAD_STATUS_PHONE_FAIL_AUTHORIZE: "휴대폰 인증에 실패 하였습니다.",
    TIMESPREAD_STATUS_PHONE_REQUEST_EXCEED: "휴대폰 인증 횟수가 초과 하였습니다.",
    TIMESPREAD_STATUS_PHONE_NOT_ACCEPTED_IP: "허용되지 않은 IP",
    TIMESPREAD_STATUS_PHONE_USER_DELETE: "탈퇴 후 7일 이후부터 휴대폰 인증 가능",
    TIMESPREAD_STATUS_LUCKYBOX_LIMIT_EXCEED: "행운상자 개수 초과",
    TIMESPREAD_STATUS_LUCKYBOX_NEED_CASH: "행운상자 도전 최소 캐시 필요",
    TIMESPREAD_STATUS_LUCKYBOX_ALREADY_OPEN: "이미 오픈된 상자",
    TIMESPREAD_STATUS_SCREEN_ALREADY_FINISH: "이미 종료된 꽉 잠금 모드"
});


/***/ }),

/***/ 25536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DK": function() { return /* binding */ ACTIVITY_TYPE_TEXT; },
/* harmony export */   "ID": function() { return /* binding */ ORDER_TEXT; },
/* harmony export */   "RO": function() { return /* binding */ ACTIVITY_TYPE_TEXT_ID; },
/* harmony export */   "T5": function() { return /* binding */ JOBTYPE_JSONLD; },
/* harmony export */   "VG": function() { return /* binding */ ACTIVITY_POST_SEARCH_ORDER_TEXT; },
/* harmony export */   "do": function() { return /* binding */ ACTIVITY_TYPE_ID_NAME; },
/* harmony export */   "fO": function() { return /* binding */ COMPANY_ANALYSIS_ORDER_TEXT; },
/* harmony export */   "g1": function() { return /* binding */ COMMUNITY_POST_SEARCH_ORDER_TEXT; },
/* harmony export */   "h0": function() { return /* binding */ COVER_LETTER_SEARCH_ORDER_TEXT; },
/* harmony export */   "i6": function() { return /* binding */ ORGANIZATIONS; },
/* harmony export */   "ic": function() { return /* binding */ USER_DELETE_REASON_TYPE_TEXT; },
/* harmony export */   "n2": function() { return /* binding */ ACTIVITY_LIST_ORDER_TEXT; }
/* harmony export */ });
/* unused harmony export JOBTYPE */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47079);
/* harmony import */ var _enums__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35460);



var _obj;
var ORDER_TEXT = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.CREATED_AT */ .Ehb.CREATED_AT, "생성일순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.RECRUIT_CLOSE_AT */ .Ehb.RECRUIT_CLOSE_AT, "마감순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.RECENT */ .Ehb.RECENT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.SCRAP_COUNT */ .Ehb.SCRAP_COUNT, "최근 스크랩 증가순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.VIEW_COUNT */ .Ehb.VIEW_COUNT, "인기순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.REPLY_COUNT */ .Ehb.REPLY_COUNT, "지원자순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.DEAD_LINE */ .Ehb.DEAD_LINE, "마감일순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.STATUS_UPDATED_AT */ .Ehb.STATUS_UPDATED_AT, "수정일순"), _obj);
var _obj1;
var ACTIVITY_LIST_ORDER_TEXT = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.CREATED_AT */ .Ehb.CREATED_AT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.SCRAP_COUNT */ .Ehb.SCRAP_COUNT, "최근 스크랩 증가순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.VIEW_COUNT */ .Ehb.VIEW_COUNT, "최근 조회 증가순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.REPLY_COUNT */ .Ehb.REPLY_COUNT, "최근 댓글 증가순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivityOrderField.RECRUIT_CLOSE_AT */ .Ehb.RECRUIT_CLOSE_AT, "마감순"), _obj1);
var _obj2;
var ACTIVITY_POST_SEARCH_ORDER_TEXT = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.CREATED_AT */ .H1T.CREATED_AT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.VIEW_COUNT */ .H1T.VIEW_COUNT, "인기순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.SCRAP_COUNT */ .H1T.SCRAP_COUNT, "스크랩순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.RECRUIT_CLOSEAT */ .H1T.RECRUIT_CLOSEAT, "마감순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .ActivitySearchOrderType.RELEVANCE */ .H1T.RELEVANCE, "관련도순"), _obj2);
var _obj3;
var COMMUNITY_POST_SEARCH_ORDER_TEXT = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj3, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CommunityPostSearchOrderField.CREATED_AT */ .GK1.CREATED_AT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj3, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CommunityPostSearchOrderField.VIEW_COUNT */ .GK1.VIEW_COUNT, "인기순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj3, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CommunityPostSearchOrderField.RELEVANCE */ .GK1.RELEVANCE, "관련도순"), _obj3);
var _obj4;
var COVER_LETTER_SEARCH_ORDER_TEXT = (_obj4 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj4, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterOrderField.RELEVANCE */ .lNF.RELEVANCE, "관련도순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj4, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterOrderField.SCRAP_COUNT */ .lNF.SCRAP_COUNT, "스크랩순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj4, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterOrderField.PASSED_AT */ .lNF.PASSED_AT, "최신순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj4, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .CoverLetterOrderField.RECENT_SCRAP_COUNT */ .lNF.RECENT_SCRAP_COUNT, "최근 인기순"), _obj4);
var _obj5;
var COMPANY_ANALYSIS_ORDER_TEXT = (_obj5 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj5, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .AnalysisReportOrderField.CREATED_AT */ ._kI.CREATED_AT, "최근 등록순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj5, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .AnalysisReportOrderField.IMPRESSION_COUNT */ ._kI.IMPRESSION_COUNT, "조회순"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj5, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .AnalysisReportOrderField.SCRAP_COUNT */ ._kI.SCRAP_COUNT, "스크랩순"), _obj5);
var _obj6;
var ORGANIZATIONS = (_obj6 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.MAJOR_COMPANY */ .BRt.MAJOR_COMPANY, "대기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.SMALL_BUSINESS */ .BRt.SMALL_BUSINESS, "중소기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.PUBLIC_INSTITUTIONS */ .BRt.PUBLIC_INSTITUTIONS, "공공기관/공기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.FOREIGN_COMPANIES */ .BRt.FOREIGN_COMPANIES, "외국계기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.MIDSIZE_BUSINESS */ .BRt.MIDSIZE_BUSINESS, "중견기업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.NON_PROFIT_ORGANIZATION */ .BRt.NON_PROFIT_ORGANIZATION, "비영리단체/협회/재단"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.START_UP */ .BRt.START_UP, "스타트업"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.BANK */ .BRt.BANK, "금융권"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.HOSPITAL */ .BRt.HOSPITAL, "병원"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.CLUB */ .BRt.CLUB, "동아리/학생자치단체"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj6, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .RecruitOrganizationType.ETC */ .BRt.ETC, "기타"), _obj6);
var _obj7;
var JOBTYPE = (_obj7 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj7, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.NEW */ .O4l.NEW, "신입"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj7, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.INTERN */ .O4l.INTERN, "인턴"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj7, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.EXPERIENCED */ .O4l.EXPERIENCED, "경력직"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj7, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.CONTRACT */ .O4l.CONTRACT, "계약직"), _obj7);
var _obj8;
/**
 * 네이버 서치어드바이저 `experienceRequirements` 가이드에 맞추어 인턴, 신입을 모두 **신입**으로 통일하고 경력직을 **경력**으로 통일합니다.
 *
 * https://searchadvisor.naver.com/guide/structured-data-job
 *
 * TODO : 추후 JOBTYPE을 다른곳에서 사용하지 않는다면 해당 상수를 삭제하고 JOBTYPE_JSONLD를 사용하는 곳에서 JOBTYPE을 사용하도록 변경합니다.
 */ var JOBTYPE_JSONLD = (_obj8 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj8, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.NEW */ .O4l.NEW, "신입"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj8, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.INTERN */ .O4l.INTERN, "신입"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj8, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.EXPERIENCED */ .O4l.EXPERIENCED, "경력"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj8, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .JobType.CONTRACT */ .O4l.CONTRACT, "계약직"), _obj8);
var _obj9;
var ACTIVITY_TYPE_TEXT = (_obj9 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY, "대외활동"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CLUB */ .kF.CLUB, "동아리"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, "공모전"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN, "인턴"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT, "채용"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj9, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION, "교육"), _obj9);
var _obj10;
var ACTIVITY_TYPE_ID_NAME = (_obj10 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.ACTIVITY */ .lY.ACTIVITY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CLUB */ .kF.CLUB, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.CLUB */ .lY.CLUB), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.CONTEST */ .lY.CONTEST), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.INTERN */ .lY.INTERN), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.RECRUIT */ .lY.RECRUIT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj10, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.EDUCATION */ .lY.EDUCATION), _obj10);
var _obj11;
var ACTIVITY_TYPE_TEXT_ID = (_obj11 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.ACTIVITY */ .lY.ACTIVITY, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.ACTIVITY */ .kF.ACTIVITY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.CLUB */ .lY.CLUB, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CLUB */ .kF.CLUB), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.CONTEST */ .lY.CONTEST, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.CONTEST */ .kF.CONTEST), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.INTERN */ .lY.INTERN, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.INTERN */ .kF.INTERN), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.RECRUIT */ .lY.RECRUIT, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.RECRUIT */ .kF.RECRUIT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj11, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeText.EDUCATION */ .lY.EDUCATION, _enums__WEBPACK_IMPORTED_MODULE_1__/* .ActivityTypeID.EDUCATION */ .kF.EDUCATION), _obj11);
var _obj12;
var USER_DELETE_REASON_TYPE_TEXT = (_obj12 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.LOW_FREQUENCY_USES */ .BFP.LOW_FREQUENCY_USES, "사용빈도 낮음"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.POOR_UX_UI */ .BFP.POOR_UX_UI, "사이트 이용 불편"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.LACK_OF_CONTENT_QUALITY */ .BFP.LACK_OF_CONTENT_QUALITY, "콘텐츠 내용 부족"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.OUT_OF_JOB_MARKET */ .BFP.OUT_OF_JOB_MARKET, "대외활동/인턴/구직활동 종료"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.POOR_SECURITY */ .BFP.POOR_SECURITY, "개인정보 유출 우려"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj12, generated_graphql__WEBPACK_IMPORTED_MODULE_0__/* .UserDeleteReasonType.ETC */ .BFP.ETC, "기타"), _obj12);


/***/ }),

/***/ 96597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29496);
/* harmony import */ var utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29229);


function useErrorSnackbar() {
    var enqueueApolloError = function enqueueApolloError(error) {
        enqueueSnackbar((0,utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__/* .getErrorMessage */ .e$)(error), {
            // @ts-ignore
            "data-testid": "snackbar-apollo-error",
            // @ts-ignore
            "data-error-code": (0,utils_apolloErrorParser__WEBPACK_IMPORTED_MODULE_1__/* .getErrorCode */ .zg)(error)
        });
    };
    var enqueueErrorMessage = function enqueueErrorMessage(message) {
        enqueueSnackbar(message, {
            // @ts-ignore
            "data-testid": "snackbar-message-error"
        });
    };
    var enqueueSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_0__/* .useSnackbar */ .Ds)().enqueueSnackbar;
    return {
        enqueueApolloError: enqueueApolloError,
        enqueueErrorMessage: enqueueErrorMessage
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useErrorSnackbar);


/***/ }),

/***/ 29229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e$": function() { return /* binding */ getErrorMessage; },
/* harmony export */   "zg": function() { return /* binding */ getErrorCode; }
/* harmony export */ });
/* unused harmony export getErrorMessageFromServer */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65155);


var getErrorCode = function(error) {
    var errorCode = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(error, "graphQLErrors[0].extensions.code", "UNKNOWN_ERROR");
    return errorCode;
};
var getErrorMessage = function(error) {
    var errorCode = getErrorCode(error);
    var message = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(_constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, errorCode, _constants_errorMessages__WEBPACK_IMPORTED_MODULE_1__/* ["default"].UNKNOWN_ERROR */ .Z.UNKNOWN_ERROR);
    return message;
};
var getErrorMessageFromServer = function(error) {
    var message = get(error, "graphQLErrors[0].message", errorMessages.UNKNOWN_ERROR);
    return message;
};


/***/ }),

/***/ 65342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ imageLoader; },
/* harmony export */   "m": function() { return /* binding */ optimizeImageUrl; }
/* harmony export */ });
var optimizeImageUrl = function(options) {
    if (!options.url) return "";
    return "".concat(options.url, "?d=").concat(options.width, "x").concat(options.height);
};
var imageLoader = function(param) {
    var src = param.src;
    return "".concat(src);
};


/***/ })

}]);